import {
  PagedResponseEmpty,
  ValidationError,
} from "@ofqual/portal-core/core/types";
import { combineReducers, AnyAction } from "redux";
import {
  CREATING_SUBMISSION,
  CREATING_SUBMISSION_VALIDATION_FAIL,
  CREATED_SUBMISSION,
  LOADING_SUBMISSIONS,
  LOADED_SUBMISSIONS,
  LOADING_SUBMISSION,
  LOADED_SUBMISSION,
  UPDATING_SUBMISSION,
  SAVED_SUBMISSION,
  UPDATING_SUBMISSION_VALIDATION_FAIL,
  DEACTIVATING_SUBMISSION,
} from "./actions";
import {
  CreateSubmissionState,
  SubmissionsState,
  SubmissionState,
} from "./state";
import { failedCrudResult, noCrudResult, successCrudResult } from "./types";

const createSubmissionInitialState: CreateSubmissionState = {
  status: "INPUTTING",
  lastCrudResult: noCrudResult(),
};

const submissionsInitialState: SubmissionsState = {
  status: "NOT_LOADED",
  response: PagedResponseEmpty,
  hasData: false,
};

const submissionInitialState: SubmissionState = {
  status: "NOT_LOADED",
  submission: null,
  lastCrudResult: noCrudResult(),
  versionId: +new Date()
};
const createSubmission = (
  state: CreateSubmissionState = createSubmissionInitialState,
  action: AnyAction
): CreateSubmissionState => {
  const { type, payload } = action;
  if (type === CREATING_SUBMISSION) {
    return {
      ...state,
      status: "CREATING",
    };
  }
  if (type === CREATING_SUBMISSION_VALIDATION_FAIL) {
    return {
      ...state,
      lastCrudResult: failedCrudResult(payload as ValidationError),
      status: "INPUTTING",
    };
  }
  if (type === CREATED_SUBMISSION) {
    return {
      ...state,
      lastCrudResult: noCrudResult(),
      status: "CREATED",
    };
  }
  return state;
};

const submissions = (
  state: SubmissionsState = submissionsInitialState,
  action: AnyAction
): SubmissionsState => {
  const { type, payload } = action;
  if (type === LOADING_SUBMISSIONS) {
    return {
      ...state,
      status: "LOADING",
    };
  }
  if (type === LOADED_SUBMISSIONS) {
    return {
      ...state,
      status: "LOADED",
      response: payload,
      hasData: true,
    };
  }
  return state;
};

const submission = (
  state: SubmissionState = submissionInitialState,
  action: AnyAction
): SubmissionState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_SUBMISSION:
    case DEACTIVATING_SUBMISSION:
      return {
        ...state,
        status: "LOADING",
        submission: null,
        lastCrudResult: noCrudResult(),
      };
    case UPDATING_SUBMISSION:
      return {
        ...state,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
    case UPDATING_SUBMISSION_VALIDATION_FAIL:
      return {
        ...state,
        lastCrudResult: failedCrudResult(payload as ValidationError),
        status: "LOADED",
      };
    case LOADED_SUBMISSION:
      return {
        ...state,
        status: "LOADED",
        submission: payload,
        versionId: +new Date()
      };
    case SAVED_SUBMISSION:
      return {
        ...state,
        status: "LOADED",
        submission: payload,
        lastCrudResult: successCrudResult(),
        versionId: +new Date()
      };
    default:
      return state;
  }
};

export const rootReducer = combineReducers({
  createSubmission,
  submissions,
  submission,
});
